(function(){
  // Prevent double-binding if someone includes this file twice
  if (window.__MINICART_BOUND__) return;
  window.__MINICART_BOUND__ = true;

  const ID = 'mini-cart';
  const HEADER_ANCHOR_SELECTOR = '#cart-icon-bubble, .header__icon--cart, [data-cart-icon], button[name="cart"]';
  const $ = (s, r=document)=>r.querySelector(s);

  function isVisible(el){ const r = el.getBoundingClientRect(); return r.width>0 && r.height>0; }
  function getCartAnchor(){ const el = document.querySelector(HEADER_ANCHOR_SELECTOR); return el && isVisible(el) ? el : null; }

  function money(cents){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '₹' + (cents/100).toFixed(2); }
  function escapeHtml(s){ return (s||'').replace(/[&<>"']/g, m=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m])); }

  function positionToAnchor(panel, arrow, anchor){
    const r = anchor.getBoundingClientRect();
    const vpW = document.documentElement.clientWidth;
    const vpH = window.innerHeight;
    const gap = 10;

    // Default below-right, clamped
    let left = Math.min(vpW - panel.offsetWidth - 8, Math.max(8, r.right - panel.offsetWidth));
    let top  = r.bottom + gap;

    // If no space below, place above
    if (top + panel.offsetHeight > vpH - 8){
      top = Math.max(8, r.top - panel.offsetHeight - gap);
      arrow.style.top = (r.top - 6) + 'px';
      arrow.style.left = (Math.min(vpW - 20, Math.max(20, r.left + 18))) + 'px';
      arrow.style.transform = 'rotate(225deg)';
    } else {
      arrow.style.top = (r.bottom - 6) + 'px';
      arrow.style.left = (Math.min(vpW - 20, Math.max(20, r.left + 18))) + 'px';
      arrow.style.transform = 'rotate(45deg)';
    }

    panel.style.left = left + 'px';
    panel.style.top  = top  + 'px';
  }

  function renderCart(cart){
    const wrap = document.getElementById(ID);
    const itemsEl = $('#mc-items', wrap);
    itemsEl.innerHTML = '';

    if (!cart.items.length){
      itemsEl.innerHTML = '<div class="mc__empty">Your cart is empty.</div>';
    } else {
      cart.items.forEach(it=>{
        const variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        const price = money(it.final_line_price || it.line_price);
        const img = (it.image) || (it.featured_image && (it.featured_image.url || it.featured_image)) || '//cdn.shopify.com/s/images/admin/no-image-large.gif';
        const row = document.createElement('div');
        row.className = 'mc__item';
        row.innerHTML = `
          <img class="mc__img" src="${img}" alt="">
          <div>
            <div class="mc__name">${escapeHtml(it.product_title || it.title)}</div>
            <div class="mc__variant">${escapeHtml(variant)}</div>
            <div class="mc__variant">Qty: ${it.quantity}</div>
          </div>
          <div class="mc__qtyprice"><div class="mc__price">${price}</div></div>
        `;
        itemsEl.appendChild(row);
      });
    }
    $('#mc-subtotal', wrap).textContent = money(cart.items_subtotal_price);
  }

  function openMiniCart(){
    const wrap = document.getElementById(ID);
    if (!wrap.hidden) return; // already open

    const panel = wrap.querySelector('.mc__panel');
    const arrow = wrap.querySelector('.mc__arrow');
    const anchor = getCartAnchor();

    // keep hidden & offscreen until data is ready and positioned (no jump)
    wrap.hidden = false;
    panel.style.opacity = '0'; panel.style.transform = 'scale(.98)';
    panel.style.left = '-9999px'; panel.style.top = '-9999px';

    fetch('/cart.js')
      .then(r=>r.json())
      .then(cart=>{
        renderCart(cart);
        requestAnimationFrame(()=>{
          if (anchor) {
            positionToAnchor(panel, arrow, anchor);
          } else {
            // Fallback: center bottom if no anchor found (rare)
            panel.style.left = '50%'; panel.style.top = (window.innerHeight- panel.offsetHeight - 12) + 'px';
            panel.style.transform = 'translateX(-50%) scale(.98)';
          }
          requestAnimationFrame(()=>{ panel.style.opacity = '1'; panel.style.transform = 'scale(1)'; });
        });
      });
  }

  function closeMiniCart(){ const wrap = document.getElementById(ID); if (wrap) wrap.hidden = true; }

  function updateCartCount(){
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      const c = cart.item_count;
      document.querySelectorAll('[data-cart-count], .cart-count-bubble .text')
        .forEach(n=>{ n.textContent = c; n.dataset.cartCount = c; });
    }).catch(()=>{});
  }

  // ---- Intercept PDP add-to-cart (also blocks Dawn's popup) ----
  document.addEventListener('submit', (e)=>{
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    // block native handlers (prevents second popup)
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();

    const fd = new FormData(form);
    fetch('/cart/add.js', { method:'POST', body:fd, headers:{Accept:'application/json'} })
      .then(r => r.ok ? r.json() : r.json().then(j=>Promise.reject(j)))
      .then(()=>{ updateCartCount(); openMiniCart(); document.dispatchEvent(new CustomEvent('cart:updated')); })
      .catch(()=> form.submit());
  }, true);

  // ---- Intercept quick-add buttons ----
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-variant-id][data-quick-add], .quick-add-button[data-variant-id]');
    if (!btn) return;

    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();

    const fd = new FormData();
    fd.append('id', btn.getAttribute('data-variant-id'));
    fd.append('quantity', btn.getAttribute('data-qty') || 1);
    const sp = btn.getAttribute('data-selling-plan-id'); if (sp) fd.append('selling_plan', sp);

    fetch('/cart/add.js', { method:'POST', body:fd, headers:{Accept:'application/json'} })
      .then(r => r.ok ? r.json() : r.json().then(j=>Promise.reject(j)))
      .then(()=>{ updateCartCount(); openMiniCart(); document.dispatchEvent(new CustomEvent('cart:updated')); })
      .catch(()=> window.location.href='/cart');
  }, true);

  // ---- Open by clicking the header cart icon (ignore clicks INSIDE dropdown so links work) ----
  document.addEventListener('click', (e)=>{
    if (e.target.closest('#' + ID)) return;
    const anchor = e.target.closest(HEADER_ANCHOR_SELECTOR);
    if (anchor) { e.preventDefault(); openMiniCart(); }
  });

  // ---- Close on outside click / ESC ----
  document.addEventListener('click', (e)=>{
    const wrap = document.getElementById(ID);
    if (wrap && !wrap.hidden){
      if (e.target.closest('[data-mc-close]')) return closeMiniCart();
      if (!e.target.closest('#' + ID) && !e.target.closest(HEADER_ANCHOR_SELECTOR)) closeMiniCart();
    }
  });
  document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') closeMiniCart(); });

  // ---- Reposition on resize/scroll while open ----
  ['resize','scroll'].forEach(ev=>{
    window.addEventListener(ev, ()=>{
      const wrap = document.getElementById(ID);
      if (wrap && !wrap.hidden){
        const anchor = getCartAnchor();
        if (!anchor) return;
        positionToAnchor($('.mc__panel', wrap), $('.mc__arrow', wrap), anchor);
      }
    });
  });
})();

